<template>
  <div class="form-container step2">
    <div class="loader" v-if="isLoading"></div>
    <form id="topup-codes-step2" @submit.prevent="submit">
      <div class="rel">
        <div class="form-row" :class="{error: form.isSubmited && !form.isAmountValid}">
          <div class="d-flex">
            <label>Kwota doładowania: <span class="red">*</span></label>
            <div>
              <ul class="topup-codes-amount">
                <li v-for="productItem in productValuesList"
                    :class="{loading: !!productItem.loading, active: isAmountActive(productItem.value), disabled: !!productItem.disabled}"
                    @click.prevent="checkAmount(productItem.value)"
                    :key="productItem.productId"
                    :value="productItem.value">
                  {{ productItem.value | pln }} PLN
                </li>
              </ul>
            </div>
          </div>
          <div class="error" v-if="form.isSubmited && !form.isAmountValid">Podaj kwotę doładowania</div>
          <div class="error" v-if="form.isAmountDisabled">Przepraszamy, to doładowanie jest chwilowo niedostępne</div>
        </div>
        <div class="form-row" :class="{error: form.isSubmited && !form.isEmailValid}">
          <div class="d-flex">
            <label for="topup-email">Adres e-mail: <span class="red">*</span></label>
            <div>
              <input type="email" v-model="form.data.notificationEmail" id="topup-email" @change="checkEmail" />
              <span class="suffix">
            <el-tooltip content="Na ten adres zostanie przesłane potwierdzenie transakcji." placement="top" :hide-after="1000">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
            </div>
          </div>
          <div class="error" v-if="form.isSubmited && !form.isEmailValid">Podaj poprawny adres e-mail</div>
        </div>
        <topup-codes-info-nintendo v-if="isProductActive(products.nintendo)" />
        <topup-codes-info-playstation-plus v-if="isProductActive(products.playstationPlus)" :time="getProductTime(form.data.amount)" />
        <topup-codes-info-playstation-store v-if="isProductActive(products.playstationStore)" />
        <topup-codes-info-settlers v-if="isProductActive(products.settlers)" />
        <topup-codes-info-spotify v-if="isProductActive(products.spotify)" :amount="form.data.amount" :time="getProductTime(form.data.amount)" />
        <topup-codes-info-xbox-live v-if="isProductActive(products.xboxGamePass)" :time="getProductTime(form.data.amount)" />
        <topup-codes-info-xbox-one v-if="isProductActive(products.xboxOne)" :amount="form.data.amount" />
        <topup-codes-info-allegro v-if="isProductActive(products.allegro)" :amount="form.data.amount" />
        <topup-codes-info-empik-card v-if="isProductActive(products.empikCard)" />
        <topup-codes-info-empik-go v-if="isProductActive(products.empikGo)" />
        <topup-codes-info-cda-premium v-if="isProductActive(products.cdaPremium)" :time="getProductTime(form.data.amount)"/>
        <topup-codes-info-player v-if="isProductActive(products.player)" :amount="form.data.amount" />
        <topup-codes-info-just-eat v-if="isProductActive(products.justEat)" :amount="form.data.amount" />
        <topup-codes-info-twitch v-if="isProductActive(products.twitch)" :amount="getProductOrigValue(form.data.amount)" />

        <div class="form-row consents">
          <h3>Zgody i oświadczenia</h3>
        </div>
        <div class="form-row d-checkbox check-all">
          <div class="with-checkbox">
            <input type="checkbox" id="check-all" v-model="checkAll">
            <label for="check-all">
              <div class="mark"></div>
              <div class="text">
                <span class="check-all">Zaznacz wszystkie</span>
              </div>
            </label>
          </div>
        </div>
        <div class="form-row d-checkbox" :class="{error: form.isSubmited && !form.data.agreeTerms}">
          <div class="with-checkbox">
            <input type="checkbox" id="terms" v-model="form.data.agreeTerms">
            <label for="terms">
              <div class="mark"></div>
              <div class="text" v-if="!isProductSony">
                <p>Oświadczam że: <span class="red">*</span></p>
                <ul>
                  <li>zapoznałem się i akceptuję <a href="/files/doladujtutaj/Kody_cyfrowe_regulamin_Autopay.pdf" target="_blank">Regulamin</a> świadczenia usług dostarczania kodów cyfrowych Autopay S.A. oraz <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank">Politykę prywatności</a></li>
                  <li>chcę, aby usługa została zrealizowana niezwłocznie i przyjmuję do wiadomości, że w przypadku pełnego wykonania usługi, z chwilą jej wykonania, utracę prawo do odstąpienia od umowy.</li>
                </ul>
              </div>
              <div class="text" v-if="isProductSony">
                <p><span class="red">*</span> Oświadczam że zapoznałem się i akceptuję <a href="/files/doladujtutaj/Kody_cyfrowe_regulamin_Autopay.pdf" target="_blank">Regulamin</a> świadczenia usług dostarczania kodów cyfrowych Autopay S.A. oraz <a href="https://autopay.pl/storage/app/media/Autopay_pl/Dokumenty/polityka-prywatnosci.pdf" target="_blank">Politykę prywatności</a></p>
              </div>
            </label>
          </div>
          <div class="error" v-if="form.isSubmited && !form.data.agreeTerms">Pole wymagane</div>
        </div>
        <div class="form-row d-checkbox">
          <div class="with-checkbox">
            <input type="checkbox" id="marketing" v-model="form.data.agreeContact">
            <label for="marketing">
              <div class="mark"></div>
              <div class="text">
                <p class="not-required">Zgoda nieobowiązkowa</p>
                <p>
                  Czy chcesz otrzymywać od nas mailowe, SMSowe lub telefoniczne powiadomienia o najlepszych ofertach<span v-if="!form.showMarketing">? <a class="toggle-more" href="" @click.prevent="form.showMarketing = true">więcej</a></span>
                  <span v-if="form.showMarketing">, promocjach, konkursach i innych ciekawych wydarzeniach organizowanych przez nas lub naszych Partnerów? Obiecujemy nie spamować! Jeżeli nasze wiadomości Ciebie znudzą, w każdej chwili możesz wycofać zgodę.
                  <span><a href="" @click.prevent="form.showMarketing = false">mniej</a></span>
                </span>
                </p>
              </div>
            </label>
          </div>
        </div>
        <div class="form-row d-checkbox">
          <div class="with-checkbox">
            <input type="checkbox" id="partner" v-model="form.data.agreeShare">
            <label for="partner">
              <div class="mark"></div>
              <div class="text">
                <p class="not-required">Zgoda nieobowiązkowa</p>
                <p>
                  Czy chcesz abyśmy mogli przekazać naszym zaufanym Partnerom Twój email lub telefon<span v-if="!form.showPartner">? <a class="toggle-more" href="" @click.prevent="form.showPartner = true">więcej</a></span>
                  <span v-if="form.showPartner">, aby mogli Tobie przedstawiać ciekawe informacje i oferty? Zapewniamy, że grono naszych Partnerów to uznane firmy, które tak jak my nie lubią spamować, a zgodę możesz w każdej chwili odwołać.
                  <span><a href="" @click.prevent="form.showPartner = false">mniej</a></span>
                </span>
                </p>
              </div>
            </label>
          </div>
        </div>
        <div class="form-row">
          <span class="red">*</span> pole wymagane
        </div>
        <div class="form-row form-buttons justify-content-between">
          <button type="button" class="btn btn-back" @click="goBack">Wstecz</button>
          <button type="submit" class="btn">Dalej</button>
        </div>
        <administrator-data-info />
        <div class="operator">
          <img :src="getOperatorLogoSrc(product, form.data.amount)" :alt="product">
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import OperatorMixin from '@/doladujtutaj/mixins/operator.mixin'
import ProductMixin from '@/doladujtutaj/mixins/product.mixin'
import { mapActions, mapMutations, mapState } from 'vuex'
import { ToolsClass } from '@/common/class/tools.class'
import AdministratorDataInfo from '@/doladujtutaj/components/AdministratorDataInfo'
import { VOUCHER_MODEL } from '@/common/const/voucher.const'
import TopupCodesInfoNintendo from '@/doladujtutaj/components/TopupCodes/InfoNintendo'
import TopupCodesInfoPlaystationPlus from '@/doladujtutaj/components/TopupCodes/InfoPlaystationPlus'
import TopupCodesInfoPlaystationStore from '@/doladujtutaj/components/TopupCodes/InfoPlaystationStore'
import TopupCodesInfoSettlers from '@/doladujtutaj/components/TopupCodes/InfoSettlers'
import TopupCodesInfoSpotify from '@/doladujtutaj/components/TopupCodes/InfoSpotify'
import TopupCodesInfoXboxLive from '@/doladujtutaj/components/TopupCodes/InfoXboxLive'
import TopupCodesInfoXboxOne from '@/doladujtutaj/components/TopupCodes/InfoXboxOne'
import TopupCodesInfoAllegro from '@/doladujtutaj/components/TopupCodes/InfoAllegro'
import TopupCodesInfoEmpikCard from '@/doladujtutaj/components/TopupCodes/InfoEmpikCard'
import TopupCodesInfoEmpikGo from '@/doladujtutaj/components/TopupCodes/InfoEmpikGo'
import TopupCodesInfoCdaPremium from '@/doladujtutaj/components/TopupCodes/InfoCdaPremium'
import TopupCodesInfoPlayer from '@/doladujtutaj/components/TopupCodes/InfoPlayer'
import TopupCodesInfoJustEat from '@/doladujtutaj/components/TopupCodes/InfoJustEat'
import TopupCodesInfoTwitch from '@/doladujtutaj/components/TopupCodes/InfoTwitch'
import { RESPONSE_STATUS } from '@/common/const/response.const'
import { Raven } from 'vue-raven'
import { PRODUCTS_SONY } from '@/common/const/operators.const'

export default {
  name: 'TopupCodesStep2',
  components: {
    TopupCodesInfoAllegro,
    TopupCodesInfoEmpikCard,
    TopupCodesInfoEmpikGo,
    TopupCodesInfoCdaPremium,
    TopupCodesInfoPlayer,
    TopupCodesInfoJustEat,
    TopupCodesInfoTwitch,
    TopupCodesInfoXboxOne,
    TopupCodesInfoXboxLive,
    TopupCodesInfoSpotify,
    TopupCodesInfoSettlers,
    TopupCodesInfoPlaystationStore,
    TopupCodesInfoPlaystationPlus,
    TopupCodesInfoNintendo,
    AdministratorDataInfo
  },
  mixins: [OperatorMixin, ProductMixin],
  computed: {
    ...mapState({
      isProductSony: state => PRODUCTS_SONY.includes(state.voucher.data.product)
    }),
    checkAll: {
      get () {
        return this.form.data.agreeTerms && this.form.data.agreeContact && this.form.data.agreeShare
      },
      set (value) {
        this.form.data.agreeTerms = value
        this.form.data.agreeContact = value
        this.form.data.agreeShare = value
      }
    }
  },
  data () {
    return {
      topupError: false,
      productValuesList: [],
      form: {
        data: ToolsClass.deepExtend(VOUCHER_MODEL),
        isAmountValid: false,
        isAmountDisabled: false,
        isEmailValid: false,
        isSubmited: false,
        showMore: false,
        showMarketing: false,
        showPartner: false
      }
    }
  },
  methods: {
    ...mapMutations([
      'SET_VOUCHER_STAGE'
    ]),
    ...mapActions([
      'checkVoucherStatus',
      'setVoucherData'
    ]),
    isAmountActive (amount) {
      amount = parseFloat(amount)
      return this.form.data.amount === amount
    },
    checkAmount (amount) {
      amount = parseFloat(amount)
      this.form.data.amount = null
      this.form.data.productId = null
      this.form.isAmountValid = false
      this.form.isAmountDisabled = false

      if (!amount || isNaN(amount)) {
        return
      }

      const isDisabled = this.productValuesList.find(item => item.value === amount).disabled
      if (isDisabled) {
        this.form.isAmountDisabled = true
        return
      }

      const productId = this.productValuesList.find(item => item.value === amount).productId
      this.form.data.amount = amount
      this.form.data.product = this.product
      this.form.data.productId = productId
      this.form.isAmountValid = true
    },
    checkEmail () {
      let email = this.form.data.notificationEmail
      if (!email || !email.length) {
        this.form.isEmailValid = false
        return
      }
      if (!ToolsClass.isEmailValid(email)) {
        this.form.isEmailValid = false
        return
      }
      this.form.isEmailValid = true
    },
    isFormValid () {
      return this.form.isAmountValid &&
        this.form.isEmailValid &&
        this.form.data.agreeTerms
    },
    goBack () {
      this.SET_VOUCHER_STAGE(1)
    },
    scrollToError () {
      setTimeout(() => {
        ToolsClass.scrollToElement(document.querySelector('.form-row.error'), -120, 'smooth')
      }, 100)
    },
    submit () {
      this.form.isSubmited = true
      this.topupError = false
      if (!this.isFormValid()) {
        this.scrollToError()
        return false
      }
      this.setVoucherData(this.form.data)
        .then(() => {
          this.SET_VOUCHER_STAGE(3)
        })
    },
    checkProductAmountStatuses () {
      this.productValues.forEach(productItem => {
        const item = ToolsClass.deepExtend(productItem)
        this.productValuesList.push(item)
        const data = {
          productId: item.productId,
          amount: item.value
        }
        item.loading = true
        this.checkVoucherStatus(data)
          .then(response => {
            item.disabled = response.body.status !== RESPONSE_STATUS.ok
          })
          .catch(error => {
            item.disabled = true
            Raven.captureMessage('DoladujTutaj checkProductAmountStatuses error', {
              extra: {
                error: error,
                product: item
              }
            })
          })
          .finally(() => {
            item.loading = false
            this.$forceUpdate()
          })
      })
    }
  },
  mounted () {
    this.checkProductAmountStatuses()
    if (this.formData !== null) {
      this.form.data = ToolsClass.deepExtend(this.formData)
      this.checkEmail()
      this.checkAmount(this.form.data.amount)
    }
  },
  updated () {
    ToolsClass.sendHeightToIframeParent()
  }
}
</script>
